var _rect, _ellipse, _path, _path2, _path3, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2FaGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 38,
    width: 59,
    height: 59,
    rx: 29.5,
    transform: "rotate(90 127 38)",
    fill: "#F1EDF7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.5,
    cy: 111.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 181.5 111.5)",
    fill: "#00FFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97 44.7148C97.5523 44.7148 98 45.1626 98 45.7148V66.1784L115.32 55.1565C115.786 54.86 116.404 54.9973 116.701 55.4633C116.997 55.9292 116.86 56.5473 116.394 56.8438L98.8625 68.0001L116.394 79.1565C116.86 79.453 116.997 80.0711 116.701 80.537C116.404 81.0029 115.786 81.1403 115.32 80.8438L98 69.8219V90.2863C98 90.8386 97.5523 91.2863 97 91.2863C96.4477 91.2863 96 90.8386 96 90.2863V69.8217L78.6796 80.8438C78.2136 81.1403 77.5956 81.0029 77.299 80.537C77.0025 80.0711 77.1399 79.453 77.6058 79.1565L95.1372 68.0001L77.6058 56.8438C77.1399 56.5473 77.0025 55.9292 77.299 55.4633C77.5956 54.9973 78.2136 54.86 78.6796 55.1565L96 66.1785V45.7148C96 45.1626 96.4477 44.7148 97 44.7148Z",
    fill: "url(#paint0_linear_8356_87599)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 44.7148C34.5523 44.7148 35 45.1626 35 45.7148V66.1784L52.3201 55.1565C52.7861 54.86 53.4041 54.9973 53.7007 55.4633C53.9972 55.9292 53.8598 56.5473 53.3939 56.8438L35.8625 68.0001L53.3939 79.1565C53.8598 79.453 53.9972 80.0711 53.7007 80.537C53.4041 81.0029 52.7861 81.1403 52.3201 80.8438L35 69.8219V90.2863C35 90.8386 34.5523 91.2863 34 91.2863C33.4477 91.2863 33 90.8386 33 90.2863V69.8217L15.6796 80.8438C15.2136 81.1403 14.5956 81.0029 14.299 80.537C14.0025 80.0711 14.1399 79.453 14.6058 79.1565L32.1372 68.0001L14.6058 56.8438C14.1399 56.5473 14.0025 55.9292 14.299 55.4633C14.5956 54.9973 15.2136 54.86 15.6796 55.1565L33 66.1785V45.7148C33 45.1626 33.4477 44.7148 34 44.7148Z",
    fill: "url(#paint1_linear_8356_87599)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 44.7148C160.552 44.7148 161 45.1626 161 45.7148V66.1784L178.32 55.1565C178.786 54.86 179.404 54.9973 179.701 55.4633C179.997 55.9292 179.86 56.5473 179.394 56.8438L161.862 68.0001L179.394 79.1565C179.86 79.453 179.997 80.0711 179.701 80.537C179.404 81.0029 178.786 81.1403 178.32 80.8438L161 69.8219V90.2863C161 90.8386 160.552 91.2863 160 91.2863C159.448 91.2863 159 90.8386 159 90.2863V69.8217L141.68 80.8438C141.214 81.1403 140.596 81.0029 140.299 80.537C140.003 80.0711 140.14 79.453 140.606 79.1565L158.137 68.0001L140.606 56.8438C140.14 56.5473 140.003 55.9292 140.299 55.4633C140.596 54.9973 141.214 54.86 141.68 55.1565L159 66.1785V45.7148C159 45.1626 159.448 44.7148 160 44.7148Z",
    fill: "url(#paint2_linear_8356_87599)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 14,
    width: 14,
    height: 14,
    rx: 7,
    transform: "rotate(90 67 14)",
    fill: "#EB3366"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8356_87599",
    x1: 116.406,
    y1: 67.6188,
    x2: 49.6938,
    y2: 86.7672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8356_87599",
    x1: 53.4058,
    y1: 67.6188,
    x2: -13.3062,
    y2: 86.7672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8356_87599",
    x1: 179.406,
    y1: 67.6188,
    x2: 112.694,
    y2: 86.7672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2FaGraphic);
export default __webpack_public_path__ + "static/media/2faGraphic.291178d5ec10687f106da47fe0f7fa4a.svg";
export { ForwardRef as ReactComponent };